<template>
    <svg width="70" height="50" viewBox="0 0 70 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.5 29.7273L12.0552 20.0168C12.3428 18.9235 13.2206 18.0848 14.3258 17.8472L41.5233 12M9.5 29.7273L14.1632 34.3967C14.6111 34.8453 15.1897 35.1404 15.8158 35.2398L33.2112 38M9.5 29.7273L29.3307 32.3644M29.3307 32.3644L33.2112 38M29.3307 32.3644L32.681 22.7272C33.012 21.775 33.7991 21.0528 34.7761 20.8046L41.5233 19.0909M60.5 14.3636L41.5233 12M60.5 14.3636V26.9565C60.5 28.2563 59.663 29.4082 58.4268 29.8098L33.2112 38M60.5 14.3636L41.5233 19.0909M41.5233 12V19.0909" stroke="currentColor"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGAccessory',
};
</script>

<style scoped lang="scss">

</style>
